/**
 * Created by guoliangfang on 2017/8/23.
 */
import _ from 'lodash';
import React from 'react';

import {Checkbox,Table} from 'antd';

const COLUMNS = [
    {
        title: 'Role Name',
        dataIndex: 'name',
        key: 'name'
    },
    {
        title: 'Role Description',
        dataIndex: 'desc',
        key: 'desc'
    },
    {
        title: '',
        dataIndex: 'operation',
        key: 'operation',
        width: 100
    }
];

class UserRoleTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            role_ids: props.selectedRole,
            role_list: {}
        };
    }

    componentDidMount() {
        this.setTable(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.setTable(nextProps);
    }

    setTable(props){
        const {dataSource,selectedRole} = props;
        this.setState({
            loading: false,
            role_ids: selectedRole,
            dataSource: dataSource && this.formatData(dataSource,selectedRole)
        });
    }

    handleCheckboxChange(role, e) {
        const {permission_id_list, id} = role;
        const list = this.state.role_list;
        let role_ids = this.state.role_ids.slice(0);
        if (e.target.checked) {
            list[id] = permission_id_list;
            role_ids.push(id);
        } else {
            role_ids = _.difference(role_ids, [id]);
            delete list[id];
        }
        const permission_list = [];
        for (const key in list) {
            list[key].filter((item) => {
                if (permission_list.indexOf(item) < 0) {
                    permission_list.push(item);
                }
            });
        }
        this.setState({
            role_ids,
            role_list: list,
            permission_list
        });
        this.props.roleSelecte(role_ids, permission_list);
    }

    formatData(data,selectedRole) {
        console.log(selectedRole);
        return data.map((item) => {
            const checked = selectedRole.indexOf(item.id) > -1;
            item.operation = <Checkbox onChange={this.handleCheckboxChange.bind(this, item)} defaultChecked={checked}/>;
            return item;
        });
    }

    render() {
        return (
            <div style={{display:this.props.show?'block':'none'}}>
                <Table
                    columns={COLUMNS}
                    size="middle"
                    loading={this.state.loading}
                    pagination={false}
                    dataSource={this.state.dataSource}/>
            </div>
        );
    }
}

UserRoleTable.defaultProps = {};

export default UserRoleTable;



// WEBPACK FOOTER //
// ./src/pages/SubAccountManagement/UserRoleTable/index.js